import { useCustomFetch } from '~/shared/lib/useCustomFetch';
import type { EventDetailDTO } from '~/shared/api/client/events/events.dto';
import {
  CLIENT_API_EVENT_DETAIL_URL,
  CLIENT_API_EVENT_DETAIL_KEY,
} from '~/shared/api/client/events/events.const';

export async function useEventDetail() {
  const route = useRoute();

  const eventId = computed(() => Number(route.params.id));

  const requestUrl = computed(
    () => `${CLIENT_API_EVENT_DETAIL_URL}${eventId.value}/`,
  );

  const { data, status, error } = await useCustomFetch<EventDetailDTO>(
    () => requestUrl.value,
    {
      method: 'GET',
      key: `${CLIENT_API_EVENT_DETAIL_KEY}_${eventId.value}`,
    },
  );

  return { data, status, error, eventId };
}
